import React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {saveData, restoreDefaultValues, cancelChanged} from '../../actions/Screen';
import {selectScrollField, isMovementsPanelShown} from '../../actions/Screen';
import {getLastLevelFields} from '../../../Common/actions/Screen';
import {textConst, texts, getLocalizedText} from '../../../../../constants/TextConst';
import {Button} from '../../../../../components/Common/Buttons/Button';
import Search from '../../../../../components/Common/Search';
import Movements from '../../../../../components/Common/Movements';
import MainMenuActionsMenu from './MainMenuActionsMenu';
import List from '../../../../../components/Common/List';
import {CollapsibleField} from '../../../../../components/Common/Collapsible';
import DesignField from '../../components/DesignField';
import checkMark from '../../../../../images/check_mark.png';

class DesignBottom extends Component<any, any> {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDefaults = this.handleDefaults.bind(this);
    }

    handleCancel() {
        const {closePanel, screen} = this.props;
        cancelChanged(screen);
        closePanel();
    }

    handleSave() {
        const {closePanel, screensStore} = this.props;
        saveData(screensStore, closePanel);
    }

    handleDefaults() {
        const {closePanel, screensStore} = this.props;
        restoreDefaultValues(screensStore, closePanel);
    }

    render() {
        return (
            <div className="panel-bottom">
                <Button
                    componentClasses="defaults-btn"
                    onClick={this.handleDefaults}
                    text={getLocalizedText(texts.defaults)}
                />
                <Button
                    componentClasses="cancel-btn"
                    onClick={this.handleCancel}
                    text={getLocalizedText(texts.cancel)}
                />
                <Button
                    componentClasses="confirm-btn"
                    onClick={this.handleSave}
                    img={checkMark}
                    alt={textConst.confirmAlt}
                    text={getLocalizedText(texts.save)}
                    labeled
                />
            </div>
        );
    }
}

@observer
class DesignList extends Component<any, any> {
    constructor(props) {
        super(props);

        this.renderItem = this.renderItem.bind(this);
    }

    renderItem({item}) {
        return (
            <CollapsibleField field={item} renderParent={DesignField} renderChild={DesignField} />
        );
    }

    render() {
        const {screen} = this.props;
        return (
            <List
                data={screen.collection.fields}
                keyExtractor={field => field.name}
                renderItem={this.renderItem}
            />
        );
    }
}

@observer
class DesignContent extends Component<any, any> {
    constructor(props) {
        super(props);

        this.selectSearchOption = this.selectSearchOption.bind(this);
    }

    selectSearchOption(field) {
        selectScrollField(field);
    }

    renderMovementsPanel() {
        const {screen} = this.props;
        return (
            <div>
                <Search
                    options={getLastLevelFields(screen)}
                    placeholder={`${getLocalizedText(texts.search)} ${getLocalizedText(
                        texts.entity
                    )}`}
                    onOptionSelect={this.selectSearchOption}
                />
                {isMovementsPanelShown(screen) && <Movements field={screen.selected} />}
            </div>
        );
    }

    renderActionsMenu() {
        const {screen, open} = this.props;
        const {active, parentScreen} = screen;
        const actionsOpen =
            open &&
            active &&
            !active.isChanging &&
            (!parentScreen || parentScreen.active === screen.active);
        return <MainMenuActionsMenu open={actionsOpen} field={active} />;
    }

    renderList() {
        const {screen} = this.props;
        const movementsPanelShown = isMovementsPanelShown(screen);
        return (
            <div className={`list ${!movementsPanelShown && 'longer'}`}>
                <div className="line" />
                <DesignList screen={screen} />
                {this.renderActionsMenu()}
            </div>
        );
    }

    render() {
        return (
            <div className="content">
                {this.renderMovementsPanel()}
                {this.renderList()}
            </div>
        );
    }
}

export const DesignMainMenu = observer(props => {
    const {screen, closePanel, screensStore, open} = props;

    return (
        <div className="screen">
            <div className={`content-wrapper`}>
                <DesignContent screen={screen} open={open} />
            </div>
            <DesignBottom screen={screen} closePanel={closePanel} screensStore={screensStore} />
        </div>
    );
});

export default DesignMainMenu;
